import { render, staticRenderFns } from "./PermissionSelect.vue?vue&type=template&id=12a3d2e2&"
import script from "./PermissionSelect.vue?vue&type=script&lang=js&"
export * from "./PermissionSelect.vue?vue&type=script&lang=js&"
import style0 from "./PermissionSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports